import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
import { LoginService } from 'src/app/services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';

@Component({
  selector: 'app-authoriserectify',
  templateUrl: './authoriserectify.component.html',
  styleUrls: ['./authoriserectify.component.css']
})
export class AuthoriserectifyComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptions: DataTables.Settings = {};
  dtOptionsOfUnauthorizeDirectorships: DataTables.Settings = {};
  dtTriggerUnAuthorizeDirectorship: Subject<any> = new Subject();
  dtOptionsOfUnauthorizSubDirector: DataTables.Settings = {};
  dtTriggerUnauthorizedSubDirector: Subject<any> = new Subject();
  dtOptionsOfUnrectifiedDirectorship: DataTables.Settings = {};
  dtOptionsOfUnrectifiedSubdirector: DataTables.Settings = {};
  dtTriggerUnrectifiedDirectorship: Subject<any> = new Subject();
  dtTriggerUnRectifiedSubDirector: Subject<any> = new Subject();
  // @ViewChildren(DataTableDirective) 
  unauthorizeDirectorList: any[];
  unauthorizeSubdirectorList: any[];
  unRectifiedDirectorList: any[];
  unRectifiedSubdirectorList: any[];
  dtTrigger: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  selectedAll: any;
  selectedAllDirectorship: any;
  allSelected: any;
  allsubdirectorselected: any;
  data: any;
  Isselected: boolean;
  checkIsslected: boolean;
  authorizeArray: any;
  subauthorizeArray: any;
  rectifyeArray: any;
  subrectifyArray: any;
  DinNumber: String;
  FirstName: String;
  MiddleName: String;
  LastName: String;
  FatherFirstName: String;
  FatherMiddleName: String;
  FatherLastName: String;
  MotherFirstName: String;
  MotherMiddleName: String;
  MotherLastName: String;
  BirthDate: any;
  SpouseFirstName: String;
  SpouseMiddleName: String;
  SpouseLastName: String;
  Occupation: String;
  AppointmentDate: any;
  ReAppointmentDate: any;
  CessationReason: String;
  CessationDate: any;
  BoardResolutionDate: any;
  Pincode: String;
  Line1: String;
  Line2: String;
  Country: String;
  State: String;
  City: String;
  present: String;
  Permanent: String;
  nationality: String
  pLine1: String;
  pLine2: String;
  pCity: String;
  pState: String;
  pCountry: String;
  pPincode: String;
  hidedirectorshipauthtable: any;
  hidesubdirectorauthtable: any;
  hidedirectorshiprectify: any;
  hidesubdirectorrectify: any;
  hideauthorizebutton: any;
  hiderectifybutton: any;
  password: any;
  CompanyName: any;
  CIN: any;
  registerOfficeAddress: any;
  IsPasswordCorrect: boolean;
  authenticationOrRectify: any;
  constructor(private directorMasterService: DirectorMasterService, private alert: AlertComponent,
      private loginService: LoginService, private route: ActivatedRoute,
     private router: Router, private activatedRoute: ActivatedRoute,private commonFunction: CommonFunction) { }

  ngOnInit() {
    
    this.environmentSettings = environment;

    this.Isselected = false;
    this.checkIsslected = false;
    this.IsPasswordCorrect = false;
    this.authorizeArray = [];
    this.unauthorizeDirectorList = [];
    this.unauthorizeSubdirectorList = [];
    this.unRectifiedDirectorList = [];
    this.unRectifiedSubdirectorList = [];
    this.dtOptionsOfUnauthorizeDirectorships = {
      destroy: true,
      scrollY: "260px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      //scrollY: "250px",
      // scrollCollapse: true,
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }]
    };

    this.dtOptionsOfUnrectifiedDirectorship = {
      destroy: true,
      scrollY: "260px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }]
    };

    this.dtOptionsOfUnauthorizSubDirector = {
      destroy: true,
      scrollY: "260px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }]
    };

    this.dtOptionsOfUnrectifiedSubdirector = {
      destroy: true,
      scrollY: "260px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }]
    };
    var companyData = JSON.parse(localStorage.getItem("companyDetails"));
    this.directorMasterService.getCompanyDetails(companyData.companyID)
      .subscribe((getData:any) => {
        var companyInformation = getData.CompanyDetails[0];
        this.CompanyName = companyInformation.CompanyName.value;
        this.CIN = companyInformation.RegistrationNumber.value;
        this.registerOfficeAddress = companyInformation.RegisteredOfficeAddress.value;
      });

    this.activatedRoute.params.subscribe(params => {
      if (params['directorId'] != undefined) {
        localStorage.setItem('DirectorId', params['directorId']);
        if (params['authrectify'] != undefined && params['authrectify'] == "authenticate") {
          this.authenticationOrRectify = "authenticate";
          this.getUnauthorizeDirectorshipsSubdirector(params['directorId']);
        }
        else if (params['authrectify'] != undefined && params['authrectify'] == "rectify") {
          this.authenticationOrRectify = "rectify";
          this.getUnRectifiedDirectorshipsSubdirector(params['directorId']);
        }

      }
    });

  }

  getUnauthorizeDirectorshipsSubdirector(directorId) {
     
    this.hidedirectorshipauthtable = false;
    this.hidesubdirectorauthtable = false;
    this.hidedirectorshiprectify = true;
    this.hidesubdirectorrectify = true;
    this.hideauthorizebutton = false;
    this.hiderectifybutton = true;
    this.unauthorizeDirectorList = [];
    this.unauthorizeSubdirectorList = [];
    this.directorMasterService.getUnauthorizeDirectorshipSubDirector(directorId)
      .subscribe((unauthorizedirectorshipList:any) => {
        this.nationality = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.Nationality;
         
        let dt;
        if (unauthorizedirectorshipList.status == 0) {
          if (unauthorizedirectorshipList.unauthorizeDataList.length > 0) {
            var table = $('#authorizedirectorshiptable').DataTable({ destroy: true });
            table.destroy();
            this.unauthorizeDirectorList = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorshipData;
            this.dtTriggerUnAuthorizeDirectorship.next();
            var table = $('#authorizeSubdirectortable').DataTable({ destroy: true });
            table.destroy();
            this.unauthorizeSubdirectorList = unauthorizedirectorshipList.unauthorizeDataList[0].SubDirectorData;
            this.dtTriggerUnauthorizedSubDirector.next();
            this.DinNumber = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.Din;
            this.FirstName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.FirstName;
            this.MiddleName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.MiddleName;
            this.LastName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.LastName;
            this.FatherFirstName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.FatherFirstName;
            this.FatherMiddleName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.FatherMiddleName;
            this.FatherLastName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.FatherLastName;
            this.MotherFirstName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.MotherFirstName;
            this.MotherMiddleName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.MotherMiddleName;
            this.MotherLastName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.MotherLastName;
            dt = this.setFormatDate(unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.DateOfBirth)
            if (dt != null) {
              this.BirthDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.BirthDate = this.BirthDate.day + "-" + this.BirthDate.month + "-" + this.BirthDate.year;
            }
            else {
              this.BirthDate = '';
            }
            this.SpouseFirstName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.SpouseFirstName;
            this.SpouseMiddleName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.SpouseMiddleName;
            this.SpouseLastName = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.SpouseLastName;
            this.Occupation = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.Occupation;
            dt = new Date(this.setFormatDate(unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.AppointmentDate));
            if (dt != null) {
              this.AppointmentDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.AppointmentDate = this.AppointmentDate.day + "-" + this.AppointmentDate.month + "-" + this.AppointmentDate.year;
            }
            else {
              this.AppointmentDate = '';
            }
            dt = this.setFormatDate(unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.ReAppointmentDate);
            if (dt != null) {
              this.ReAppointmentDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.ReAppointmentDate = this.ReAppointmentDate.day + "-" + this.ReAppointmentDate.month + "-" + this.ReAppointmentDate.year;
            }
            else {
              this.ReAppointmentDate = '';
            }
            this.CessationReason = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.CessationReason;
            dt = this.setFormatDate(unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.CessationDate);
            if (dt != null) {
              this.CessationDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.CessationDate = this.CessationDate.day + "-" + this.CessationDate.month + "-" + this.CessationDate.year;
            }
            else {
              this.CessationDate = '';
            }
            dt = this.setFormatDate(unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.BoardResolutionDate);
            if (dt != null) {
              this.BoardResolutionDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.BoardResolutionDate = this.BoardResolutionDate.day + "-" + this.BoardResolutionDate.month + "-" + this.BoardResolutionDate.year;
            }
            else {
              this.BoardResolutionDate = '';
            }
            this.Line1 = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PresentResidentialAddress.Line1;
            this.Line2 = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PresentResidentialAddress.Line2;
            this.Country = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PresentResidentialAddress.Country;
            this.State = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PresentResidentialAddress.State;
            this.City = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PresentResidentialAddress.City;
            this.Pincode = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PresentResidentialAddress.PinCode;
            this.present = this.Line1 + "," + this.Line2 + "," + this.City + "," + this.State + "," + this.Country + "," + this.Pincode;
            this.pLine1 = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PermenantResidentialAddress.Line1;
            this.pLine2 = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PermenantResidentialAddress.Line2;
            this.pCountry = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PermenantResidentialAddress.Country;
            this.pState = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PermenantResidentialAddress.State;
            this.pCity = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PermenantResidentialAddress.City;
            this.pPincode = unauthorizedirectorshipList.unauthorizeDataList[0].DirectorData.PermenantResidentialAddress.PinCode;
            this.Permanent = this.pLine1 + "," + this.pLine2 + "," + this.pState + "," + this.pCity + "," + this.pPincode;

            this.dtTrigger.next();
          }
          else {
            this.unauthorizeDirectorList = [];
            this.unauthorizeSubdirectorList = [];
          }
        }

      });
  }
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }
  getUnRectifiedDirectorshipsSubdirector(directorId) {
     
    this.hidedirectorshipauthtable = true;
    this.hidesubdirectorauthtable = true;
    this.hidedirectorshiprectify = false;
    this.hidesubdirectorrectify = false;
    this.hideauthorizebutton = true;
    this.hiderectifybutton = false;
    let dt;
    this.unRectifiedDirectorList = [];
    this.unRectifiedSubdirectorList = [];
    this.directorMasterService.getUnRectifiedDirectorshipSubDirector(directorId)
      .subscribe((unRectifieddirectorshipList:any) => {
         
        if (unRectifieddirectorshipList.status == 0) {
          if (unRectifieddirectorshipList.unrectifiedDataList.length > 0) {
            var table = $('#rectifydirectorshiptable').DataTable({ destroy: true });
            table.destroy();
            this.unRectifiedDirectorList = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorshipData;
            this.dtTriggerUnrectifiedDirectorship.next();
            var table = $('#rectifySubdirectortable').DataTable({ destroy: true });
            table.destroy();
            this.unRectifiedSubdirectorList = unRectifieddirectorshipList.unrectifiedDataList[0].SubDirectorData;
            this.dtTriggerUnRectifiedSubDirector.next();
            this.DinNumber = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.Din;
            this.FirstName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.FirstName;
            this.MiddleName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.MiddleName;
            this.LastName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.LastName;
            this.FatherFirstName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.FatherFirstName;
            this.FatherMiddleName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.FatherMiddleName;
            this.FatherLastName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.FatherLastName;
            this.MotherFirstName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.MotherFirstName;
            this.MotherMiddleName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.MotherMiddleName;
            this.MotherLastName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.MotherLastName;
            this.nationality = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.Nationality;
            dt = this.setFormatDate(unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.DateOfBirth)
            if (dt != null) {
              this.BirthDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.BirthDate = this.BirthDate.day + "-" + this.BirthDate.month + "-" + this.BirthDate.year;
            }
            else {
              this.BirthDate = '';
            }
            this.SpouseFirstName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.SpouseFirstName;
            this.SpouseMiddleName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.SpouseMiddleName;
            this.SpouseLastName = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.SpouseLastName;
            this.Occupation = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.Occupation;
            dt = new Date(this.setFormatDate(unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.AppointmentDate));
            if (dt != null) {
              this.AppointmentDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.AppointmentDate = this.AppointmentDate.day + "-" + this.AppointmentDate.month + "-" + this.AppointmentDate.year;
            }
            else {
              this.AppointmentDate = '';
            }
            dt = this.setFormatDate(unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.ReAppointmentDate);
            if (dt != null) {
              this.ReAppointmentDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.ReAppointmentDate = this.ReAppointmentDate.day + "-" + this.ReAppointmentDate.month + "-" + this.ReAppointmentDate.year;
            }
            else {
              this.ReAppointmentDate = '';
            }
            this.CessationReason = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.CessationReason;
            dt = this.setFormatDate(unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.CessationDate);
            if (dt != null) {
              this.CessationDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.CessationDate = this.CessationDate.day + "-" + this.CessationDate.month + "-" + this.CessationDate.year;
            }
            else {
              this.CessationDate = '';
            }
            dt = this.setFormatDate(unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.BoardResolutionDate);
            if (dt != null) {

              this.BoardResolutionDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.BoardResolutionDate = this.BoardResolutionDate.day + "-" + this.BoardResolutionDate.month + "-" + this.BoardResolutionDate.year;
            }
            else {
              this.BoardResolutionDate = '';
            }
            this.Line1 = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PresentResidentialAddress.Line1;
            this.Line2 = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PresentResidentialAddress.Line2;
            this.Country = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PresentResidentialAddress.Country;
            this.State = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PresentResidentialAddress.State;
            this.City = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PresentResidentialAddress.City;
            this.Pincode = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PresentResidentialAddress.PinCode;
            this.present = this.Line1 + "," + this.Line2 + "," + this.City + "," + this.State + "," + this.Country + "," + this.Pincode;
            this.pLine1 = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PermenantResidentialAddress.Line1;
            this.pLine2 = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PermenantResidentialAddress.Line2;
            this.pCountry = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PermenantResidentialAddress.Country;
            this.pState = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PermenantResidentialAddress.State;
            this.pCity = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PermenantResidentialAddress.City;
            this.pPincode = unRectifieddirectorshipList.unrectifiedDataList[0].DirectorData.PermenantResidentialAddress.PinCode;
            this.Permanent = this.pLine1 + "," + this.pLine2 + "," + this.pState + "," + this.pCity + "," + this.pPincode;
            this.dtTrigger.next();
          }
          else {
            this.unRectifiedDirectorList = [];
            this.unRectifiedDirectorList = [];
          }
        }

      });
  }

  selectAll() {
    for (var i = 0; i < this.unauthorizeDirectorList.length; i++) {
      this.unauthorizeDirectorList[i].SelectedDirectorship = this.selectedAll;
      this.Isselected = this.selectedAll;
    }
  }

  selectAllDirectorshipToRectify() {
    for (var i = 0; i < this.unRectifiedDirectorList.length; i++) {
      this.unRectifiedDirectorList[i].SelectedDirectorship = this.selectedAllDirectorship;
      this.checkIsslected = this.selectedAllDirectorship;
    }
  }

  allSelect() {
    for (var i = 0; i < this.unauthorizeSubdirectorList.length; i++) {
      this.unauthorizeSubdirectorList[i].SelectedSubdirector = this.allSelected;
      this.Isselected = this.allSelected;
    }
  }

  checkIfAllSelected() {
    this.selectedAll = this.unauthorizeDirectorList.every(function (item: any) {
      return item.SelectedDirectorship == true;
    })
  }

  checkIfAllDirectorshipSelected() {
    this.selectedAllDirectorship = this.unRectifiedDirectorList.every(function (item: any) {
      return item.SelectedDirectorship == true;
    })
  }

  checksubIfAllSelected() {
    this.allSelected = this.unauthorizeSubdirectorList.every(function (item: any) {
      return item.SelectedSubdirector == true;
    })
  }

  allSubdirectorSelect() {
    for (var i = 0; i < this.unRectifiedSubdirectorList.length; i++) {
      this.unRectifiedSubdirectorList[i].SelectedSubdirector = this.allsubdirectorselected;
      this.checkIsslected = this.allsubdirectorselected;
    }
  }
  checksubrectifyIfAllSelected() {
    this.allsubdirectorselected = this.unRectifiedSubdirectorList.every(function (item: any) {
      return item.SelectedSubdirector == true;
    })
  }

  checkselected(ev) {
    if (ev.target.checked == true) {
      this.Isselected = true;
    }
    else {
      this.Isselected = false;
    }
  }
  checkrectifyselected(ev) {
    if (ev.target.checked == true) {
      this.checkIsslected = true;
    }
    else {
      this.checkIsslected = false;
    }
  }

  checkPassword() {
     
    if (this.password == null) {
      this.alert.error('Please enter password.');
      return false;
    }
    var user = JSON.parse(localStorage.getItem("user"));
    var decrEmailId=this.commonFunction.decrypt(user.EmailId);
    let loginModel = {
      // "UserName": user.EmailId,
      "UserName": decrEmailId,
      "Password": this.password,
      "CompanyId": user.CompanyId
    };
    this.loginService.login(loginModel)
      .subscribe(data => {
        if (data.status == 0) {
          if (this.authenticationOrRectify == "authenticate") {
            this.authorize();
          }
          else if (this.authenticationOrRectify == "rectify") {
            this.rectify();
          }
        }
        else {
          this.alert.error('Password is incorrect.');
          this.password = null;
          return false;
        }
      })
  }

  authorize() {
     
    var authorizedDirectorCompanyName = '', authorizedSubDirectorCompanyName = '';
    this.authorizeArray = [];
    this.subauthorizeArray = [];
    for (let unauthorizeDirector of this.unauthorizeDirectorList) {
      if (unauthorizeDirector.SelectedDirectorship === true) {
        authorizedDirectorCompanyName = authorizedDirectorCompanyName + ',' + unauthorizeDirector.OfficeName;
        this.authorizeArray.push(unauthorizeDirector);
      }
    }

    if (authorizedDirectorCompanyName != '') {
      if (authorizedDirectorCompanyName.substr(0, 1) == ',') {
        authorizedDirectorCompanyName = authorizedDirectorCompanyName.substr(1);
        authorizedSubDirectorCompanyName = authorizedDirectorCompanyName;
      }
    }

    for (let unauthorizeSubdirector of this.unauthorizeSubdirectorList) {
      if (unauthorizeSubdirector.SelectedSubdirector === true) {
        authorizedSubDirectorCompanyName = authorizedSubDirectorCompanyName + ',' + unauthorizeSubdirector.CompanyName;
        this.subauthorizeArray.push(unauthorizeSubdirector);
      }
    }

    if (authorizedSubDirectorCompanyName != '') {
      if (authorizedSubDirectorCompanyName.substr(0, 1) == ',') {
        authorizedSubDirectorCompanyName = authorizedSubDirectorCompanyName.substr(1);
      }
    }

    var authorizedata = {
      "Directorship": this.authorizeArray,
      "SubDirector": this.subauthorizeArray
    }
    console.log('authorizedata',authorizedata)
    this.directorMasterService.authorize(authorizedata)
      .subscribe((directorship:any) => {
        console.log('directorship.status',directorship);
        if (directorship.status == 0) {
           
          var table = $('#authorizedirectorshiptable').DataTable({ destroy: true });
          table.destroy();
          var table = $('#authorizeSubdirectortable').DataTable({ destroy: true });
          table.destroy();
          this.Isselected = false;//disable authorize button
          this.selectedAll = false;//uncheck all authorize director
          this.allSelected = false;//unchecheck all authorize sub director
          this.getUnauthorizeDirectorshipsSubdirector(localStorage.getItem('DirectorId'));
          this.alert.success(authorizedSubDirectorCompanyName + ' Company is authorized successfully.');
          this.password = null;
          return true;
          //this.router.navigate(['/director']);                 
        }
        else {
          this.alert.error('Record rectification is failed.');
          this.password = null;
          return false;
        }
      });
  }

  rectify() {
     
    var rectifiedDirectorCompanyName = '', rectifiedSubDirectorCompanyName = '';
    this.rectifyeArray = [];
    this.subrectifyArray = [];
    for (let unRectifiedDirector of this.unRectifiedDirectorList) {
      if (unRectifiedDirector.SelectedDirectorship === true) {
        rectifiedDirectorCompanyName = rectifiedDirectorCompanyName + ',' + unRectifiedDirector.OfficeName;
        this.rectifyeArray.push(unRectifiedDirector);
      }
    }

    if (rectifiedDirectorCompanyName != '') {
      if (rectifiedDirectorCompanyName.substr(0, 1) == ',') {
        rectifiedDirectorCompanyName = rectifiedDirectorCompanyName.substr(1);
        rectifiedSubDirectorCompanyName = rectifiedDirectorCompanyName;
      }
    }

    for (let unRectifiedSubDirector of this.unRectifiedSubdirectorList) {
      if (unRectifiedSubDirector.SelectedSubdirector === true) {
        rectifiedSubDirectorCompanyName = rectifiedSubDirectorCompanyName + ',' + unRectifiedSubDirector.CompanyName;
        this.subrectifyArray.push(unRectifiedSubDirector);
      }

      if (rectifiedSubDirectorCompanyName != '') {
        if (rectifiedSubDirectorCompanyName.substr(0, 1) == ',') {
          rectifiedSubDirectorCompanyName = rectifiedSubDirectorCompanyName.substr(1);
        }
      }
    }
    var rectifydata = {
      "Directorship": this.rectifyeArray,
      "SubDirector": this.subrectifyArray
    }
    console.log('rectifydata',rectifydata)
    this.directorMasterService.rectify(rectifydata)
      .subscribe((directorship:any) => {
        console.log('directorship.status',directorship);
        if (directorship.status == 0) {
           
          var table = $('#rectifydirectorshiptable').DataTable({ destroy: true });
          table.destroy();
          var table = $('#rectifySubdirectortable').DataTable({ destroy: true });
          table.destroy();
          this.checkIsslected = false;//disable rectify button
          this.selectedAllDirectorship = false;//uncheck all authorize director
          this.allsubdirectorselected = false;//uncheck all rectify subdirector
          this.password = null;
          this.getUnRectifiedDirectorshipsSubdirector(localStorage.getItem('DirectorId'));
          this.alert.success(rectifiedSubDirectorCompanyName + ' Company is rectified successfully.');
          return true;
          // this.router.navigate(['/director']);
        }
        else {
          this.alert.error('Record rectification is failed.');
          this.password = null;
          return false;
        }
      });
  }

  Confirmation() {
    $('#confirmation').modal('toggle');
  }

  registerDirector() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['director']  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/director']);
  }

}



